'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { KeyboardShortcutsDrawer } from './keyboard-shortcuts-drawer';
import { shouldEnableKeyboardShortcutsDrawer } from '@/lib/keyboard-shortcuts/registry';
export function KeyboardShortcutsController(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const enabled = shouldEnableKeyboardShortcutsDrawer(pathname);
  if (!enabled) {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <KeyboardShortcutsDrawer />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children) {
    t2 = <>{children}{t1}</>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}